import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FacturaGastoDtoOut, GastoDtoIn, GastoDtoOut } from '../models/gasto.model';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadGastoService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/contabilidad-onda/gastos`;

  constructor(private readonly http: HttpClient) {}

  crearGasto(gasto: GastoDtoIn): Observable<GastoDtoOut> {
    return this.http.post<GastoDtoOut>(this.endpoint, gasto).pipe(catchError(this.handleError('crearGasto')));
  }

  actualizarGasto(gasto: GastoDtoIn, id: number): Observable<GastoDtoOut> {
    return this.http
      .put<GastoDtoOut>(`${this.endpoint}/${id}`, gasto)
      .pipe(catchError(this.handleError('actualizarGasto')));
  }

  eliminarGasto(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('eliminarGasto')));
  }

  obtenerGastoPorId(id: number): Observable<GastoDtoOut> {
    return this.http.get<GastoDtoOut>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('obtenerGastoPorId')));
  }

  obtenerGastos(): Observable<GastoDtoOut[]> {
    return this.http.get<GastoDtoOut[]>(this.endpoint).pipe(catchError(this.handleError('obtenerGastos')));
  }

  exportarGastoExcel(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-excel`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarGastoExcel')));
  }

  exportarGastoCsv(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-csv`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarGastoCsv')));
  }

  obtenerFacturasParaGasto(idEmpresaFacturadora: number): Observable<FacturaGastoDtoOut[]> {
    return this.http
      .get<FacturaGastoDtoOut[]>(`${this.endpoint}/facturas-para-gasto/${idEmpresaFacturadora}`)
      .pipe(catchError(this.handleError('obtenerFacturasParaGasto')));
  }

  cambiarCodigoAlbaran(gastoId: number, nuevoCodigoAlbaran: number): Observable<void> {
    return this.http
      .put<void>(`${this.endpoint}/${gastoId}/cambiar-codigo-albaran`, { nuevoCodigoAlbaran: nuevoCodigoAlbaran })
      .pipe(catchError(this.handleError('cambiarCodigoAlbaran')));
  }

  private handleError(operation: string) {
    return (error: any) => {
      console.error(`ContabilidadGastoService - Error en operación [${operation}]:`, error);
      throw error;
    };
  }

  validarGasto(id: number): Observable<void> {
    return this.http
      .put<void>(`${this.endpoint}/${id}/validar-gasto`, {})
      .pipe(catchError(this.handleError('validarGasto')));
  }

  getFacturasNoProcesables(): Observable<FacturaGastoDtoOut[]> {
    return this.http
      .get<FacturaGastoDtoOut[]>(`${this.endpoint}/facturas-no-procesables`)
      .pipe(catchError(this.handleError('getFacturasNoProcesables')));
  }
}
